const escapeHtml = (s) =>
  s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

const applyInlineFormatting = (s) => {
  let out = s;
  out = out.replace(/`([^`\n]+)`/g, "<code>$1</code>");
  out = out.replace(/\*\*([^*\n]+)\*\*/g, "<strong>$1</strong>");
  out = out.replace(/__([^_\n]+)__/g, "<strong>$1</strong>");
  out = out.replace(/(^|[^*])\*([^*\n]+)\*(?!\*)/g, "$1<em>$2</em>");
  out = out.replace(/(^|[^_])_([^_\n]+)_(?!_)/g, "$1<em>$2</em>");
  out = out.replace(
    /\[([^\]]+)\]\(([^)\s]+)\)/g,
    '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
  );
  return out;
};

const markdownToHtml = (text) => {
  if (!text) return "";
  const escaped = escapeHtml(text.replace(/\r\n/g, "\n"));
  const lines = escaped.split("\n");
  const blocks = [];
  let i = 0;

  const isHeading = (t) => /^#{1,6}\s+/.test(t);
  const isHr = (t) => /^(-{3,}|\*{3,}|_{3,})$/.test(t);
  const isUl = (t) => /^[-*+]\s+/.test(t);
  const isOl = (t) => /^\d+\.\s+/.test(t);
  const isQuote = (t) => /^>\s+/.test(t);
  const isFence = (t) => /^```/.test(t);

  while (i < lines.length) {
    const line = lines[i];
    const trimmed = line.trim();

    if (!trimmed) {
      i++;
      continue;
    }

    if (isFence(trimmed)) {
      i++;
      const codeLines = [];
      while (i < lines.length && !isFence(lines[i].trim())) {
        codeLines.push(lines[i]);
        i++;
      }
      if (i < lines.length) i++;
      blocks.push(`<pre><code>${codeLines.join("\n")}</code></pre>`);
      continue;
    }

    const headingMatch = trimmed.match(/^(#{1,6})\s+(.+?)\s*#*$/);
    if (headingMatch) {
      const level = headingMatch[1].length;
      blocks.push(
        `<h${level}>${applyInlineFormatting(headingMatch[2])}</h${level}>`
      );
      i++;
      continue;
    }

    if (isHr(trimmed)) {
      blocks.push("<hr>");
      i++;
      continue;
    }

    if (isQuote(trimmed)) {
      const quoteLines = [];
      while (i < lines.length && isQuote(lines[i].trim())) {
        quoteLines.push(lines[i].trim().replace(/^>\s+/, ""));
        i++;
      }
      blocks.push(
        `<blockquote><p>${applyInlineFormatting(
          quoteLines.join(" ")
        )}</p></blockquote>`
      );
      continue;
    }

    if (isUl(trimmed)) {
      const items = [];
      while (i < lines.length && isUl(lines[i].trim())) {
        items.push(
          applyInlineFormatting(lines[i].trim().replace(/^[-*+]\s+/, ""))
        );
        i++;
      }
      blocks.push(`<ul>${items.map((it) => `<li>${it}</li>`).join("")}</ul>`);
      continue;
    }

    if (isOl(trimmed)) {
      const items = [];
      while (i < lines.length && isOl(lines[i].trim())) {
        items.push(
          applyInlineFormatting(lines[i].trim().replace(/^\d+\.\s+/, ""))
        );
        i++;
      }
      blocks.push(`<ol>${items.map((it) => `<li>${it}</li>`).join("")}</ol>`);
      continue;
    }

    const paraLines = [];
    while (i < lines.length) {
      const l = lines[i];
      const t = l.trim();
      if (!t) break;
      if (
        isHeading(t) ||
        isFence(t) ||
        isQuote(t) ||
        isUl(t) ||
        isOl(t) ||
        isHr(t)
      ) {
        break;
      }
      paraLines.push(l);
      i++;
    }
    if (paraLines.length > 0) {
      blocks.push(
        `<p>${applyInlineFormatting(paraLines.join("<br>"))}</p>`
      );
    }
  }

  return blocks.join("");
};

const looksLikeMarkdown = (text) => {
  if (!text || text.length < 3) return false;
  const patterns = [
    /^#{1,6}\s+/m,
    /\*\*[^*\n]+\*\*/,
    /__[^_\n]+__/,
    /^[-*+]\s+/m,
    /^\d+\.\s+/m,
    /^>\s+/m,
    /```[\s\S]*?```/,
    /\[[^\]]+\]\([^)\s]+\)/,
  ];
  return patterns.some((re) => re.test(text));
};

export { markdownToHtml, looksLikeMarkdown };
